// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel d’éducation culturelle et artistique
// https://ifpc-fwb.be/v5/documents/tc/refECA.pdf
// SHA-256 90ddb81aba94aacaadbb39ea7e3c65a3571556ab342ae76c1e37576e518300d9
// P3: pages 35-39, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "ECA-P3-c9acbf4d",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "",
    parent: "Exploiter au moins un exemple pour chacune des trois rubriques.",
    text: "Sélectionner au moins un exemple par mode d’expression. En expression musicale, choisir au moins une référence pour l’écoute et une pour l’expression.",
  },
  {
    id: "ECA-P3-9519f49f",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "",
    parent: "Découvrir : - Un lieu de spectacle (par ex : théâtre, salle de concert, chapiteau…).",
    text: "Expression française et corporelle - Théâtre de rue/cirque. - Danses de société, en couple, en groupe…",
  },
  {
    id: "ECA-P3-de290215",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "",
    parent: "- Un lieu patrimonial belge (par ex : Atomium, Grand-Place de Bruxelles, Bruges, Gare de Liège, Cathédrale de Tournai, Ascenseur à bateaux, site minier…).",
    text: "Expression musicale ▶ Écoute : Notamment en lien avec S2 (cordophones*), par ex : - « Les Quatre Saisons », A. Vivaldi, interprétation de Camille et Julie Berthollet. - « Gymnopédies », E. Satie. - « Concerto d’Aranjuez », pour guitare et orchestre, J. Rodrigo. - « Bambino », Dalida, version OSS 117. - « Imagine », J. Lennon. - Le « Canon », J. Pachelbel. - Oum Kalthoum. - « Pierre et le Loup », S. Prokofiev. - …",
  },
  {
    id: "ECA-P3-bc35b579",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "",
    parent: "- Des objets multiculturels (par ex : statuette, objet artisanal, habit, chapeau, jeu*, narguilé, masque africain, tajine, poncho…).",
    text: "▶ Expression : - La Brabançonne Notamment en lien avec SF2 et SF4, par ex : - Canons à deux voix (par ex : « Vent frais », « Dans la forêt lointaine », « Django », « Rumbali »). - Répertoire musical lié au quotidien des élèves. - …",
  },
  {
    id: "ECA-P3-a356b313",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "",
    parent: "- Des objets multiculturels (par ex : statuette, objet artisanal, habit, chapeau, jeu*, narguilé, masque africain, tajine, poncho…).",
    text: "Expression plastique - La représentation du mouvement en art (par ex : C. Twombly, K. Hokusai, V. Vasarely, W. Leblanc, les futuristes Italiens, E. Degas…). - Les artistes illustrateurs (par ex : H. Davies, R. Tasker, K. Canby, J.-M. Folon, A. Warhol...). - La géométrie dans l’art (par ex : D. Buren, S. Delaunay, V. Vasarely, pavages islamiques, motifs hindous, vitraux…).",
  },
  {
    id: "ECA-P3-18e4bcbf",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S1 : Éléments liés aux lieux de culture, au patrimoine* et aux objets culturels.",
    text: "Suite aux visites et observations de préférence in situ, décrire : - un lieu culturel et de spectacle (théâtre, concert, cinéma, chapiteau…) ; - des éléments du patrimoine* matériel belge ; - des œuvres et/ou objets de cultures diverses.",
  },
  {
    id: "ECA-P3-2ffe23c1",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Temps/Rythme*.",
    text: "Expression française et corporelle Décrire la temporalité entre les danseurs ou dans le jeu* théâtral : répétition, succession, alternance, enchainement…",
  },
  {
    id: "ECA-P3-9bb138fe",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Temps/Rythme*.",
    text: "Expression musicale Identifier et définir la pulsation* et le rythme*.",
  },
  {
    id: "ECA-P3-a52c659d",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Temps/Rythme*.",
    text: "Expression plastique Exemplifier la représentation en miroir.",
  },
  {
    id: "ECA-P3-e352196e",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Temps/Rythme*.",
    text: "Expression française et corporelle Décrire : - la voix : intensité, hauteur, pause, respiration (voir P1 et P2 en expression musicale) ; - la position du corps (équilibre/déséquilibre, transferts d’appuis…) ; - l’énergie des mouvements (lourd/léger, aquatique, aérien…).",
  },
  {
    id: "ECA-P3-941a5366",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Corps/Gestes/Voix/Outils.",
    text: "Expression musicale Définir la ligne mélodique*, la direction sonore (notes ascendantes, répétées et descendantes).",
  },
  {
    id: "ECA-P3-4872448e",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Corps/Gestes/Voix/Outils.",
    text: "Expression plastique Décrire les qualités et les caractéristiques des outils et des matériaux (poudre, liquide, épais, souple, transparent…).",
  },
  {
    id: "ECA-P3-d098642a",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Corps/Gestes/Voix/Outils.",
    text: "Décrire les effets produits par ses gestes et les outils utilisés.",
  },
  {
    id: "ECA-P3-cf7492a1",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Corps/Gestes/Voix/Outils.",
    text: "Expression française et corporelle Décrire des trajectoires (par ex : droites, en cercle, en zigzag...).",
  },
  {
    id: "ECA-P3-20d1031d",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Espaces/Formes/Matières/Supports.",
    text: "Expression musicale Décrire des formes musicales (des structures) au travers de chansons traditionnelles apprises : ABA*, ABACA*, ABC*, ritournelle*…",
  },
  {
    id: "ECA-P3-15ba3dd2",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Espaces/Formes/Matières/Supports.",
    text: "Expression plastique Exemplifier des formes géométriques et organiques (régulières ou non…).",
  },
  {
    id: "ECA-P3-e006ed9b",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Couleurs/Timbres*.",
    text: "Expression française et corporelle Décrire les éléments scénographiques suivants : le décor et les accessoires.",
  },
  {
    id: "ECA-P3-6fa18a62",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Couleurs/Timbres*.",
    text: "Expression musicale Reconnaitre visuellement et auditivement des cordophones* d’ici ou d’ailleurs.",
  },
  {
    id: "ECA-P3-8f9cb121",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S2 : Couleurs/Timbres*.",
    text: "Expression plastique Identifier les couleurs primaires, secondaires, complémentaires.",
  },
  {
    id: "ECA-P3-c54aad22",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir",
    parent: "S3 : Contexte*/Fonction*/Sens.",
    text: "Identifier les messages véhiculés dans les expériences culturelles et artistiques vécues.",
  },
  {
    id: "ECA-P3-240bdc79",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF1 : Observer* de manière multisensorielle : regarder, écouter, gouter, sentir, toucher, apprécier*.",
    text: "Exprimer ses observations de spectacles, d’œuvres et d’objets culturels variés.",
  },
  {
    id: "ECA-P3-dec56b2d",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF1 : Garder des traces.",
    text: "Classer, ordonner les traces culturelles récoltées.",
  },
  {
    id: "ECA-P3-93dfae3f",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Expression française et corporelle Alterner des trajectoires, des positions d’équilibre et de déséquilibre.",
  },
  {
    id: "ECA-P3-90a23443",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Varier les transferts d’appuis, l’énergie, l’intensité des mouvements et la temporalité entre les danseurs.",
  },
  {
    id: "ECA-P3-57233511",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Exercer le travail de la voix (intensité, hauteur, pause, respiration).",
  },
  {
    id: "ECA-P3-5c2745dc",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Expression musicale Chanter des chansons à l’unisson et des canons simples, à deux voix avec accompagnement acoustique/numérique ou a capella*.",
  },
  {
    id: "ECA-P3-e6c3c802",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "À l’audition : - frapper le rythme* de chansons ou d’extraits instrumentaux ; - reconnaitre une forme musicale* (une structure) simple : ABA*, ABACA*, ABC*, ritournelle*…",
  },
  {
    id: "ECA-P3-9bc9bec5",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Expression plastique Expérimenter les spécificités des outils et des matériaux (qualités, caractéristiques et effets produits).",
  },
  {
    id: "ECA-P3-51dd4107",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF2 : Utiliser des outils, des instruments, le corps, l’image*, le son, la voix.",
    text: "Mettre en relation, dans un format choisi librement, des couleurs primaires, secondaires, complémentaires.",
  },
  {
    id: "ECA-P3-16f2a259",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF3 : Interroger le contexte*, la fonction* et le sens d’éléments culturels.",
    text: "Lors de la découverte d’un élément culturel ou artistique, interroger l’intérêt de la diversité culturelle.",
  },
  {
    id: "ECA-P3-2a1bb27b",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF3 : Classer des œuvres et des objets culturels selon des critères.",
    text: "Lors de la découverte d’un élément culturel ou artistique, établir des liens interculturels.",
  },
  {
    id: "ECA-P3-dc8f3d71",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF3 : Classer des œuvres et des objets culturels selon des critères.",
    text: "Expression française et corporelle Imaginer des situations de jeu* avec différentes utilisations de la voix.",
  },
  {
    id: "ECA-P3-b7ef9448",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Exercer son imagination, sa créativité.",
    text: "Proposer un enchainement corporel en lien avec les fondamentaux abordés durant l’année.",
  },
  {
    id: "ECA-P3-9792a988",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Exercer son imagination, sa créativité.",
    text: "Expression musicale Improviser des séquences rythmiques à partir de différentes parties du corps (pieds, cuisses, mains, poitrine, doigts…).",
  },
  {
    id: "ECA-P3-0f7c5abb",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Exercer son imagination, sa créativité.",
    text: "Expression plastique Utiliser des formes géométriques et organiques au départ de techniques variées.",
  },
  {
    id: "ECA-P3-95c813dc",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Exercer son imagination, sa créativité.",
    text: "Explorer les façons de donner une impression de mouvement par des formes et des couleurs.",
  },
  {
    id: "ECA-P3-0e06e6a8",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Partager une réalisation.",
    text: "Expression française et corporelle Travailler la fluidité et l’équilibre dans un espace scénique défini.",
  },
  {
    id: "ECA-P3-94520db8",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Partager une réalisation.",
    text: "Expression musicale Exécuter en plusieurs groupes un canon de percussions corporelles ou instrumentales.",
  },
  {
    id: "ECA-P3-eb4f3d07",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Savoir-faire",
    parent: "SF4 : Partager une réalisation.",
    text: "Expression plastique Présenter une production artistique et un projet de mise en valeur des travaux.",
  },
  {
    id: "ECA-P3-4ea1a86f",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C1 : Fréquenter des lieux, des œuvres* et des objets culturels variés.",
    text: "Appréhender, de préférence in situ, des lieux, des œuvres et des objets de diverses cultures, et les comparer.",
  },
  {
    id: "ECA-P3-1399318c",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C1 : Fréquenter des lieux, des œuvres* et des objets culturels variés.",
    text: "Expression française et corporelle Identifier des fondamentaux abordés lors de rencontres.",
  },
  {
    id: "ECA-P3-78109e5e",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C2 : Décoder les fondamentaux des trois modes d’expressions artistiques, par des pratiques et au travers d’œuvres, de genres, de cultures et d’époques différentes.",
    text: "Expression musicale Chanter en frappant les rythmes* sur différentes parties du corps (par ex : doigts, mains, poitrine, cuisses, pieds…).",
  },
  {
    id: "ECA-P3-a0fca5e0",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C2 : Décoder les fondamentaux des trois modes d’expressions artistiques, par des pratiques et au travers d’œuvres, de genres, de cultures et d’époques différentes.",
    text: "Expression plastique Exemplifier la représentation de mouvement dans une production plastique*.",
  },
  {
    id: "ECA-P3-cc81f955",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C3 : Interpréter le sens d’éléments culturels.",
    text: "Partager et échanger ses ressentis, ses émotions et ses expériences culturelles, pour prendre la mesure de la diversité.",
  },
  {
    id: "ECA-P3-1feb9560",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C4 : Créer collectivement et/ou individuellement.",
    text: "Expression française et corporelle Imaginer et réaliser une mise en voix et une mise en espace, en lien avec les savoirs abordés durant l’année.",
  },
  {
    id: "ECA-P3-33fc0884",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C4 : Créer collectivement et/ou individuellement.",
    text: "Expression musicale Réaliser, en petits groupes, des productions musicales à partir de l’expression vocale, de la percussion corporelle ou de la pratique instrumentale.",
  },
  {
    id: "ECA-P3-276dccee",
    champ: "",
    section: "Repères culturels et artistiques",
    kind: "Compétence",
    parent: "C4 : Créer collectivement et/ou individuellement.",
    text: "Expression plastique Créer une œuvre plastique personnelle qui traduit un mouvement.",
  },
];
